import api from 'data/api';

export const loadAffiliates = api('GET /api/mobile/lookups/affiliates');
